export const content = {
  tooltip: (n: number) => `${n} verschiedene Status`,
};
